import { render, staticRenderFns } from "./AddDomainView.vue?vue&type=template&id=6f02f66d&"
import script from "./AddDomainView.vue?vue&type=script&lang=js&"
export * from "./AddDomainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports